import { useNavigate } from "react-router-dom";
import { OrgList } from "../components/OrgList.js";

/**
 * Landing route (US-B1/B2/B3). The org picker; choosing an org opens its default-ad
 * listing, and selecting a set + "Author ad for selected" opens the create form pre-loaded
 * with those org ids (US-D5 — wired in Task 5.2).
 */
export function OrgPickerPage() {
  const navigate = useNavigate();
  return (
    <main>
      <OrgList
        onSelectOrg={(org) => navigate(`/orgs/${org.id}/ads`)}
        onAuthorForSelected={(orgIds, adsType) =>
          navigate(`/orgs/${orgIds[0]}/ads/new`, { state: { orgIds, adsType } })
        }
      />
    </main>
  );
}
